/*----- Start Update Image Banner Heading on Home Page -----*/
function updateImageBannerText() {
    console.log('Starting updateImageBannerText function.');
    const imageBannerHeading = document.getElementsByClassName("banner__heading")[0];
    imageBannerHeading.innerHTML = "<span style='color:#fdb933;'>Amazing</span> New Look.<br>Same <span style='color:#fdb933;'>Great Taste</span>.";
}
window.addEventListener('load', function() {
    console.log('DOM is loaded.');
    updateImageBannerText();
})

/*----- End Update Image Banner Heading on Home Page -----*/